export default {
    pcd: "18",
    pname: "福井県",
    header: "Go To Eatキャンペーン 福井県プレミアム食事券　申込",
    explanation: "本サイトは、GoToEatキャンペーン福井県プレミアム食事券の申込受付サイトです。\nGoToEatキャンペーン福井県プレミアム食事券の申込方法をご案内しますので、以下に同意したうえでメールアドレスのご登録をお願いいたします。",
    personalinfo: "ご入力いただきました個人情報は、GoToEatキャンペーン福井県プレミアム食事券の販売のために使用いたします。\n個人情報は、法令に基づく場合を除き、ご本人様の承諾なしに第三者（弊社業務委託先を除く）に提供することはありません。",
    cid: "gfukui",
    unitdetails: "12,500円（1,000円×10枚　500円×5枚）／1セット",
    ticketvalue: 12500,
    unitprice: 10000,
    maxunits: 2,
    quantityoptions: [
        {value: "1", text: "1"},
        {value: "2", text: "2"},
    ],
    starttime: "10:00",
    startdatenotice: {
        header:"◆GoToEatキャンペーン福井県プレミアム食事券の引き取り開始日時についての注意事項◆",
        danger: "お引き取り開始につきましては、お申込み日の翌日10:00からとなりますのでご注意ください。",
        body: "GoToEatキャンペーン福井県プレミアム食事券の申込みを頂きありがとうございます。\n\nご登録頂きました、メールアドレス宛に配信されます【GoToEatキャンペーン福井県プレミアム食事券】申込完了通知の内容をご確認の上、お近くのファミリーマートにてお支払い、食事券のお受取りをお願いいたします。"
    },
};
